import React, { useEffect, useState } from 'react';
import BACK from '../images/icon-back-b.svg';
import { useForm, SubmitHandler } from 'react-hook-form';
import axios from 'axios';
import HEADER from "../Components/header";
import baseUrlApi from '../lib/baseUrlApi';
import SensorSettingModalEdit from '../Components/SensorSetting/SensorSettingModalEdit';
import {SensorConfigInputs} from "../Consts/typs";
import { useNavigate, useParams } from "react-router-dom";
import {useCookies} from "react-cookie";
import siteAdmin from "./SiteAdmin";
import {ApiRequest} from "../Consts/ApiRequest";
import MessageComponent from "../Components/MessageComponent";
type Param = {
    siteId?: string;
    siteRecno?: string;
};

const SensorConfig = () => {
    const navigate = useNavigate();
    const [sensorId, setsensorId] = useState<string>("");
    const [sensorName, setSensorName] = useState<string>("");
    const [siteName, setSiteName] = useState<string>("");
    const [SensorConfigData, setSensorConfigData] = useState<SensorConfigInputs[]>([]);
    const [sensorRecno, setSensorRecno] = useState<number>(0);
    const [state, setState] = useState("")
    const { register, handleSubmit, formState: { errors } } = useForm<SensorConfigInputs>();
    const [cookies, setCookie, removeCookie] = useCookies(['authority', 'access_token', "siteId", "siteRecno"]);
    const params: Param = useParams<Param>();
    const siteRecno = params.siteRecno;
    const siteId = params.siteId;

    const changeState = (isState: string) => {
        setState(isState)
        getSensorSetting();
    }

    useEffect(() => {
        if(cookies.authority == 4) {
            removeCookie('access_token', {path: '/'});
            removeCookie('authority', {path: '/'});
            removeCookie('siteId', {path: '/'});
            removeCookie('siteRecno', {path: '/'});
            navigate("logout");
        }
        getSensorSetting();
    }, []);

    const getSensorSetting = async () => {
        let params = {
            "siteRecno": siteRecno,
            "prcKind": 0,
        };
        const token = cookies.access_token || "";
        await ApiRequest.getSensorSetting(params, token,
            (response: any) => {
            setSensorConfigData(response.data.sensors);
        }, (error: any) => {
            errorCallback(error);
        });
    }

    function errorCallback(error:any){
        if (error.response && error.response.status === 401) {
            console.error("Error token error:", error);
            removeCookie('access_token', {path: '/'});
            removeCookie('authority', {path: '/'});
            removeCookie('siteId', {path: '/'});
            removeCookie('siteRecno', {path: '/'});
            navigate("logout");
        }
        console.error("Error fetching dataSite:", error);
    }

    useEffect(() => {
        const token = cookies.access_token || "";
        var params = {
            siteId: siteId ?? "",
            siteRecno: siteRecno ?? ""
        };
        ApiRequest.getSiteSetting(params, token,
            (response:any) => {
            setSiteName(response.data.siteName);
        }, (error:any) => {
            errorCallback(error);
        });

        var params2 = {
            "siteId" :siteId,
            "siteRecno" :siteRecno,
            "prcKind": 0,
        };
        ApiRequest.getSensorSetting(params2, token,
            (response:any) => {
                console.log(response);
                setSensorConfigData(response.data.sensors);
            }, (error:any) => {
                errorCallback(error);
            });
    }, []);

    const onSubmit: SubmitHandler<SensorConfigInputs> = async (data) => {
        setSensorConfigData([]);

        try {
            let params = {
                "prcKind": 1,
                "siteRecno": siteRecno,
                "sensorRecno": sensorRecno,
                "sensorId": sensorId,
                "sensorName": sensorName,
            };
            const token = cookies.access_token || "";
            await ApiRequest.getSensorSetting(params, token,
                (response: any) => {
                    if (response.data && Array.isArray(response.data.sensors)) {
                        setSensorConfigData(response.data.sensors);
                    }
                    console.log(response);
                }, (error: any) => {
                    errorCallback(error);
                });
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const getSepString = (str :string, sep :string, defaultStr :string = "") => {
        if(!str) return defaultStr;
        return str? str + sep : defaultStr ;
    }

    return (
        <>
            <div className="wrapper">
                <HEADER
                    showMenu={1}
                    siteId={siteId}
                    siteRecno={siteRecno}
                    siteName={siteName}
                />
                <main className="main">
                    <section className="page-head" id="page-head">
                        <div className="page-head-block">
                            <div className="page-name">
                                <a onClick={() => navigate(-1)}>
                                    <img src="https://www.sooki-cloud-portalsystem.jp/static/media/icon-back-b.a302f48a196965a4ff8d4568031a609b.svg" alt="戻る" />
                                </a>
                                <div className="page-name-label">センサ設定</div>
                            </div>
                            <div className="page-option">
                            </div>
                        </div>
                    </section>
                    <section className="page-body scroll-block">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="search-box">
                                <div className="search-box-elm">
                                    <div className="search-box-elm-name">管理番号(センサ)</div>
                                    <div className="search-box-elm-input">
                                        <input
                                            type="text"
                                            value={sensorId}
                                            placeholder="sensorId"
                                            className="col-320 "
                                            onChange={e => setsensorId(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="search-box-elm">
                                    <div className="search-box-elm-name">センサ名</div>
                                    <div className="search-box-elm-input">
                                        <input
                                            type="text"
                                            value={sensorName}
                                            placeholder="sensorName"
                                            className="col-320 "
                                            onChange={e => setSensorName(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="search-box-btn">
                                    <button className="btn btn-white-line"><i className="icon-search-w"></i>検索</button>
                                </div>
                            </div>
                        </form>

                        <div className="table-box">
                            <table className="st-table">
                                <thead>
                                    <tr>
                                        <th className="">センサ管理番号</th>
                                        <th className="">センサ名</th>
                                        <th className="">項目</th>
                                        <th className="">計測値変換</th>
                                        {/* 表示内容不明 */}
                                        <th className="">閾値(1次上限、2次上限、1次下限、2次下限)</th>

                                        <th className="">グラフスケール</th>
                                        <th className="">メール送信</th>
                                        <th className="">メール送信間隔</th>
                                        <th className="">メモ</th>
                                        <th className="col-100">編集</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {SensorConfigData.map((item, index) => (
                                        <tr key={index}>
                                            <td className="nowrap">
                                                {item.sensorId}
                                            </td>
                                            <td className="nowrap">
                                                <MessageComponent message={item.sensorName} maxLength={8}/>
                                            </td>
                                            {/* 項目 */}
                                            <td className="nowrap">{item.childName}</td>
                                            {/* 計測値変換 */}
                                            <td className="nowrap">
                                                {getSepString(item.waterConfig?.minDigital, " , ", "-")}
                                                {getSepString(item.waterConfig?.minAnalog, " | ")}
                                                {getSepString(item.waterConfig?.maxDigital, " , ")}
                                                {getSepString(item.waterConfig?.maxAnalog, "")}
                                            </td>
                                            {/* しきい値 */}
                                            <td className="nowrap">
                                                {item.childKind !== 6 ? (getSepString(item.config?.upThrehold.toString(), " , ")) : (item.config.upThrehold == -100.00 ? (getSepString("  -  "," , ")) : (getSepString(item.config.upThrehold.toString(), " , ")))}
                                                {item.childKind !== 6 ? (getSepString(item.config?.upupThrehold.toString(), " | ")) : (item.config.upupThrehold == 0.00 || item.config.upupThrehold == -100.00 ? (getSepString("  -  "," ")) : (getSepString(item.config.upupThrehold.toString(), " ")))}
                                                {item.childKind !== 6 ? (getSepString(item.config?.lowThrehold.toString(), " , ")) : (<></>)}
                                                {item.childKind !== 6 ? (getSepString(item.config?.lowlowThrehold.toString(), "")): (<></>)}
                                            </td>
                                            {/* グラフスケール */}
                                            <td className="nowrap">
                                                {getSepString(item?.graph?.xScale?.toString(), " , ", "-")}
                                                {getSepString(item?.graph?.yScale?.toString(), "")}
                                            </td>
                                            {/* メール送信 */}
                                            <td>
                                                {item.mail.isSend ?
                                                    <i className="icon-check-b" /> :
                                                    "-"
                                                }
                                            </td>
                                            {/* メール送信間隔 */}
                                            <td className="nowrap">
                                                {getSepString(item.mail?.sendSpan, "")}
                                            </td>
                                            {/* メモ */}
                                            <td className="nowrap">
                                                <MessageComponent message={getSepString(item.comment, "", "-")} maxLength={8}/>
                                            </td>
                                            {/* 編集 */}
                                            <td className="">
                                                <SensorSettingModalEdit
                                                    item={item}
                                                    sensorId={item.sensorId}
                                                    sensorRecno={item.sensorRecno}
                                                    sensorName={item.sensorName}
                                                    sensorKind={item.sensorKind}
                                                    lowThrehold={item.config?.lowThrehold}
                                                    lowlowThrehold={item.config?.lowlowThrehold}
                                                    upThrehold={item.config?.upThrehold}
                                                    upupThrehold={item.config?.upupThrehold}
                                                    minAnalog={item.waterConfig?.minAnalog}
                                                    maxAnalog={item.waterConfig?.maxAnalog}
                                                    minDigital={item.waterConfig?.minDigital}
                                                    maxDigital={item.waterConfig?.maxDigital}
                                                    isSend={item.mail.isSend}
                                                    sendSpan={item.mail.sendSpan}
                                                    xScale={item.graph?.xScale}
                                                    yScale={item.graph?.yScale}
                                                    xRange={item.graph?.xRange}
                                                    yMax={item.graph?.yMax}
                                                    yMin={item.graph?.yMin}
                                                    childKind={item.childKind}
                                                    comment={item.comment}
                                                    setState={changeState}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </section>
                </main>
            </div>
        </>
    )
};
export default SensorConfig;
